import PlainSurface, { Props as PlainSurfaceProps } from './plain-surface'


export default PlainSurface

export type { PlainSurfaceProps }
